export default __webpack_public_path__ + "static/media/14 - Birth of Cephalobaby.9132b229.jpeg";